export default __webpack_public_path__ + "80c013a43d0c90ae810c0e40085175ca.svg";